export const TableStyles = {
  // IDs like Verve ID, Employee ID
  idCell: "text-[10px] uppercase tracking-tight whitespace-nowrap font-normal",
  
  // Primary prominent text (Names, Titles)
  primaryText: "text-brand-dark tracking-tight text-sm leading-tight truncate font-normal",
  
  // Secondary text (Emails, Phones, Subtitles)
  secondaryText: "text-[10px] text-slate-400 truncate tracking-tighter font-normal",
  
  // Tag-like texts (Source, Type)
  badge: "text-[10px] text-slate-500 uppercase tracking-tighter bg-slate-50 px-2 py-0.5 rounded font-normal",
  
  // Note text
  noteText: "text-[11px] text-slate-600 italic block py-1 font-normal",
  
  // Standard regular text (Locations, Phones, generic info)
  regularText: "text-[11px] text-slate-600 font-normal truncate",
  
  // Action icons
  actionIcon: "text-slate-400 hover:text-brand-blue cursor-pointer transition-colors"
};
